import { get as apiGet } from 'api'

export const getFolderGroups = async (monthsBack) => {
  const params = monthsBack !== undefined && monthsBack !== null ? `?monthsBack=${monthsBack}` : ''
  return apiGet(`/Dashboard/GetFolderGroups${params}`)
}
